import { render, staticRenderFns } from "./RefundList.vue?vue&type=template&id=b8bf1338&"
import script from "./RefundList.vue?vue&type=script&lang=js&"
export * from "./RefundList.vue?vue&type=script&lang=js&"
import style0 from "./RefundList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8bf1338')) {
      api.createRecord('b8bf1338', component.options)
    } else {
      api.reload('b8bf1338', component.options)
    }
    module.hot.accept("./RefundList.vue?vue&type=template&id=b8bf1338&", function () {
      api.rerender('b8bf1338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Requests/RefundList.vue"
export default component.exports